import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Building2, HeartPulse, Landmark, ShoppingBag } from 'lucide-react';
export function UseCases() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const useCases = [{
    icon: Building2,
    title: 'Servicios Financieros',
    description: 'Apertura de cuentas, préstamos y transacciones con verificación KYC instantánea y segura.'
  }, {
    icon: HeartPulse,
    title: 'Salud',
    description: 'Acceso a historiales médicos y servicios de telemedicina protegiendo la privacidad del paciente.'
  }, {
    icon: Landmark,
    title: 'Gobierno',
    description: 'Trámites digitales, votación electrónica y servicios públicos con identidad verificada.'
  }, {
    icon: ShoppingBag,
    title: 'Comercio Digital',
    description: 'Compras online, marketplaces y verificación de edad sin fricciones ni riesgos de fraude.'
  }];
  return <section id="casos-uso" className="py-20 md:py-32 bg-navy-800/30" ref={ref} data-id="element-367">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-368">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-369">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-370">
            Identidad digital para cada industria
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-371">
            Soluciones adaptadas a las necesidades específicas de tu sector
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-372">
          {useCases.map((useCase, index) => {
          const Icon = useCase.icon;
          return <motion.div key={useCase.title} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-373">
                <div className="bg-navy-900 border border-teal-500/20 rounded-xl p-6 hover:border-teal-500 hover:shadow-lg hover:shadow-teal-500/10 transition-all group h-full" data-id="element-374">
                  <div className="w-14 h-14 bg-teal-500/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-500/20 transition-colors" data-id="element-375">
                    <Icon size={28} className="text-teal-500" data-id="element-376" />
                  </div>
                  <h3 className="text-xl font-display font-semibold text-white mb-3" data-id="element-377">
                    {useCase.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-378">
                    {useCase.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}